import { API } from '@/api';

export const classes = {
  paper:
    'fixed top-8 rounded-2xl px-6 py-4 w-[90vw] max-w-[600px] min-w-[200px] max-h-[80vh]',
  header: 'pt-0 pb-4 place-between',
  breadcrumbs: 'text-grey-8 dark:text-mauve-1 font-semibold',
  buttons: 'flex items-center gap-4',
  empty: 'text-grey-6 dark:text-mauve-3 text-center text-xl py-8',
};

export async function moveFile(
  fileId: number,
  oldCollectionId: number,
  newCollectionId: number
) {
  return API.FileCollections.updateFileCollectionFile(
    fileId,
    oldCollectionId,
    newCollectionId
  );
}

export async function moveCollection(
  fileCollectionId: number,
  parentFileCollectionId: number
) {
  return API.FileCollections.updateFileCollection(fileCollectionId, {
    parentFileCollectionId,
  });
}
